export default __webpack_public_path__ + "static/kepi-886a6aaebd608cc06f7a1487a8b11f55.jpg";